import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import {
  gridFilterModelSelector,
  useGridApiContext,
} from "@mui/x-data-grid-pro";
import { useEffect, useState } from "react";

const PredefinedFilters = ({ predefinedFilters }) => {
  const apiRef = useGridApiContext();
  const currentFilterModel = gridFilterModelSelector(apiRef);
  const [active, setActive] = useState();
  const isSameFilterModel = (a, b) => {
    if (!a || !b) return false;
    if (a.items.length !== b.items.length) return false;
    for (let i = 0; i < a.items.length; i++) {
      const itemA = { ...a.items[i] };
      const itemB = { ...b.items[i] };
      delete itemA.id;
      delete itemB.id;
      if (JSON.stringify(itemA) !== JSON.stringify(itemB)) return false;
    }
    return true;
  };

  useEffect(() => {
    predefinedFilters &&
      setActive(
        predefinedFilters.findIndex(({ filterModel }) =>
          isSameFilterModel(currentFilterModel, filterModel),
        ),
      );
  }, [currentFilterModel, predefinedFilters]);

  const handleChange = (e) => {
    const index = parseInt(e.target.value);
    const filterModel = predefinedFilters[index]?.filterModel;
    if (!filterModel || active === index) {
      apiRef.current.setFilterModel({
        items: [],
      });
      return;
    }
    apiRef.current.setFilterModel(filterModel);
  };

  return (
    predefinedFilters && (
      <ToggleButtonGroup
        value={active}
        exclusive
        onChange={handleChange}
        aria-label="Platform"
      >
        {predefinedFilters.map(({ name }, index) => (
          <ToggleButton size="small" key={index} value={index}>
            {name}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    )
  );
};

export default PredefinedFilters;
